import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImagePlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M9.25 1.75h-5.5a2 2 0 0 0-2 2v8.833m0 0v3.667a2 2 0 0 0 2 2h12.5a2 2 0 0 0 2-2v-3.5l-3.75-3.5-3.75 2.5m-9 .833L7 8.25l6.25 6.5M12.75 4H16m0 0h3.25M16 4V.75M16 4v3.25"
	})]
});
const ForwardRef = forwardRef(SvgImagePlus);
export { ForwardRef as ReactComponent };
